module.exports = __webpack_public_path__ + "static/img/mb-11.f770658.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h5/mb-11.jpg
// module id = 8Rfz
// module chunks = 1